import { Button, ButtonTheme } from 'components/Button';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useDispatch } from 'react-redux';
import { SET_OFFSET } from 'store/actions';
import {
  selectSearchAssetIds,
  selectSearchIsFiltered,
  selectSearchRequest,
  selectSearchTotal,
} from 'store/search/selectors';

export const CloudAssetListFooter: React.FC = () => {
  const dispatch = useDispatch();
  const { bottom } = useSafeAreaInsets();
  const { limit, offset } = useSelector(selectSearchRequest);
  const total = useSelector(selectSearchTotal);
  const isFiltered = useSelector(selectSearchIsFiltered);
  const assetIds = useSelector(selectSearchAssetIds);

  const changeOffset = React.useCallback(() => {
    if (total !== null && limit + offset < total) {
      dispatch(SET_OFFSET(limit + offset));
    }
  }, [limit, offset, total, dispatch]);

  const totalToLoad = total ? total - assetIds.length : 0;
  const showLoadMore = !!totalToLoad;

  return (
    <View style={styles.buttonContainer}>
      {showLoadMore && (
        <View style={styles.moreAssetsContainer}>
          <Button
            buttonTheme={ButtonTheme.primary}
            onPress={changeOffset}
            text="Load More Assets"
          />
          <Txt style={styles.moreAssetsText}>{`${Number(
            totalToLoad,
          ).toLocaleString()} More Asset${totalToLoad === 1 ? '' : 's'}`}</Txt>
        </View>
      )}
      {total !== null && !totalToLoad && (
        <View style={{ paddingBottom: bottom }}>
          <Txt style={styles.loadingText}>
            {total === 0 ? 'No Assets Available' : 'No More Assets'}
          </Txt>
          {isFiltered && (
            <Txt weight="bold" style={styles.loadingTextSub}>
              Try changing or removing filters
            </Txt>
          )}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 85,
    paddingTop: theme.grid,
  },
  loadingText: {
    textAlign: 'center',
  },
  loadingTextSub: {
    textAlign: 'center',
  },
  moreAssetsContainer: {
    alignItems: 'center',
  },
  moreAssetsText: {
    marginVertical: 5,
  },
});
